import { usePlaygroundDispatch, usePlaygroundState } from "../usePlaygroundContext";
import { setPlaygroundPopoverOpen } from "../playgroundSlice";
import { Button } from "@altimateai/lego";
import { RobotIcon } from "@/assets/icons";
import { IconX } from "@tabler/icons-react";
import { useRef } from "react";
import PlaygroundPopover, { PlaygroundPopoverRef } from "./PlaygroundPopover";
import { useLocation } from "react-router-dom";
import { GlobalPlaygroundStatus } from "./GlobalPlaygroundStatus";

// Disabled routes - includes playground and all non-authenticated routes from Routes.tsx
const DisabledRoutes = [
  "/studio",
  "/demo",
  "/login",
  "/login-redirect/okta",
  "/register",
  "/forgot",
  "/reset",
  "/verified",
  "/contactus",
  "/expired",
  "/kb/", // Public knowledge catalog details
];
const GlobalPlaygroundButton = () => {
  const dispatch = usePlaygroundDispatch();
  const { isPlaygroundPopoverOpen } = usePlaygroundState();
  const location = useLocation();
  const popoverRef = useRef<PlaygroundPopoverRef>(null);

  console.log("GlobalPlaygroundButton render - isOpen:", isPlaygroundPopoverOpen);
  if (DisabledRoutes.find(path => location.pathname.includes(path))) {
    return null;
  }

  const handleClick = () => {
    dispatch(setPlaygroundPopoverOpen(!isPlaygroundPopoverOpen));
  };

  const resetStatus = () => {
    popoverRef.current?.resetStatus();
  };

  return (
    <>
      <div className="al-fixed al-bottom-2 al-right-6 al-z-[50]">
        <Button
          onClick={handleClick}
          variant={"ghost"}
          size="icon"
          title={
            isPlaygroundPopoverOpen
              ? "Close Studio"
              : "Uncover insights and take action regarding this entity using Studio"
          }
          className="!al-size-12 al-text-white hover:al-text-white al-transition-all hover:al-scale-105 active:al-scale-95 !al-rounded-full al-bg-gradient-to-br al-from-[#247EFE] al-to-[#8F00FF] al-p-0"
          aria-label={isPlaygroundPopoverOpen ? "Close Studio AI" : "Open Studio AI"}
        >
          <span className="al-relative al-w-6 al-h-6">
            <RobotIcon
              className={`!al-w-6 !al-h-6 al-absolute al-inset-0 al-transition-all al-duration-300 ${
                isPlaygroundPopoverOpen
                  ? "al-opacity-0 al-scale-50 al-rotate-90"
                  : "al-opacity-100 al-scale-100 al-rotate-0"
              }`}
            />
            <IconX
              size={24}
              className={`!al-w-6 !al-h-6 al-absolute al-inset-0 al-transition-all al-duration-300 ${
                isPlaygroundPopoverOpen ? "al-opacity-100 al-rotate-0" : "al-opacity-0 al-rotate-90"
              }`}
            />
          </span>
        </Button>
      </div>
      <GlobalPlaygroundStatus onDismiss={resetStatus} />
      <PlaygroundPopover ref={popoverRef} />
    </>
  );
};

export default GlobalPlaygroundButton;
